module.exports = __webpack_public_path__ + "static/phone.292a3a71.png";